import React from 'react'
import './ErrorOverlayView.scss'

import {getLanguageScope} from '../../../../helpers'
const _i18n = getLanguageScope('error_overlay');

import {ERROR_TYPES} from "../../../../constants";
import MAYA from '../../../../maya_api'

import {Modal, Header, Button, Icon} from 'semantic-ui-react'

class TimeoutOverlay extends React.Component {
  constructor(props){
    super(props);
  }

  reset(){
    const {resetError} = this.props;

    setTimeout(() => {
      resetError();
      return MAYA.logout()
    }, 5000);
  }

  renderModal(){
    const {type} = this.props;

    let message = _i18n('unexpected_error');

    if(!type){
      this.reset();
    }

    if(type === ERROR_TYPES.AUTH_TOKEN_ERROR){
      message = _i18n('auth_token_error');

      this.reset();
    }

    if(type === ERROR_TYPES.ACCESS_DENIED){
      message = _i18n('access_denied');

      this.reset();
    }

    if(type === ERROR_TYPES.DEVICE_NOT_FOUND){
      message = _i18n('device_not_found');

      this.reset();
    }

    if(type === ERROR_TYPES.USER_NOT_FOUND){
      message = _i18n('user_not_found');

      this.reset();
    }

    return (
      <Modal
        style={{height: 'auto'}}
        open={true}
        basic
        closeOnDocumentClick={false}
        size='small'
      >
        <Header icon='ban' content={message}/>
        <Modal.Content>
          <h3>{`${_i18n('logout')}`}</h3>
        </Modal.Content>
      </Modal>
    )
  }

  render(){
    const {showErrorPopup} = this.props;

    if(!showErrorPopup) return null;

    return this.renderModal();
  }
}

export default TimeoutOverlay


// WEBPACK FOOTER //
// ./src/components/shared/ErrorOverlay/components/ErrorOverlayView.js